"use client";

import { useAui } from "@assistant-ui/react";
import { useEffect, useRef } from "react";
import { useRouteContext } from "./contexts/routeContext";
import { ClientLogger } from "@/lib/clientLogger";

/**
 * Headless component that auto-sends the decoded prompt (from `#prompt=` URL
 * fragment or `?prompt=` query parameter) as the first message on a new thread,
 * then clears it from state so a page refresh won't re-fire.
 */
export function PromptAutoSend() {
  const aui = useAui();
  const routeContext = useRouteContext();
  const hasFired = useRef(false);

  useEffect(() => {
    if (!routeContext.prompt) return;
    if (hasFired.current) return;

    hasFired.current = true;
    const text = routeContext.prompt;

    ClientLogger.info("Prompt auto-send triggered", {
      component: "PromptAutoSend",
      metadata: {
        source: routeContext.promptSource ?? "unknown",
        length: text.length,
      },
    });

    aui.thread().append({
      role: "user",
      content: [{ type: "text", text }],
    });

    routeContext.onRouteStateChanged({ prompt: undefined, promptSource: undefined });
  }, [routeContext.prompt, aui, routeContext]);

  return null;
}
